import React from 'react';
import { HorizontalRule } from '@piggybank/core';

export const HorizontalRuleHook = () => <HorizontalRule />;
